import { render } from "./VerifyDocumentData.vue?vue&type=template&id=2dc902e0&lang=true"
import script from "./VerifyDocumentData.vue?vue&type=script&lang=js"
export * from "./VerifyDocumentData.vue?vue&type=script&lang=js"

import "./VerifyDocumentData.vue?vue&type=style&index=0&id=2dc902e0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__